import { updateMerkzettelStateInMenu } from "@modules/bookmarks/bookmarks-menu-item.ts"
import { InfoPanel } from "@modules/info-panel/InfoPanel.ts"
import { Cookie } from "@modules/util/Cookie.ts"

export async function lookForBookmarksThatCanBeMerged() {
    if (userData.userId === 0) {
        return
    }

    const modal = document.getElementById("move-from-session-modal")
    if (!modal) {
        return
    }

    const hideMergeCookieModal = getHideMergeCookieModal()
    if (hideMergeCookieModal) {
        return
    }

    $(modal).modal("show")

    const confirmButton = document.querySelector(".confirm-session-move-all") as HTMLButtonElement

    confirmButton.addEventListener("click", async () => {
        await fetch(`api/bookmarks/${userData.userId}/merge-cookie-entries`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
        })
            .then(async (apiResponse: Response) => {
                if (!apiResponse.ok) {
                    let json: any = null
                    try {
                        json = await apiResponse.json()
                    } catch (err) {}
                    if (json?.messageId === "MERGE_COOKIE_ENTRIES_DENIED")
                        InfoPanel.displayMessage(
                            "Der Cookie-Merkzettel konnte nicht verschoben werden. Die maximale Anzahl an Elementen darf nicht größer als 50 sein." +
                                json?.message,
                            InfoPanel.Type.Error,
                            10 * 1000,
                            $(modal).modal("hide"),
                        )
                    return
                }
                $(modal).modal("hide")

                updateMerkzettelStateInMenu(true)

                InfoPanel.displayMessage(
                    "Der Cookie-Merkzettel wurde erfolgreich verschoben.",
                    InfoPanel.Type.Success,
                    5 * 1000,
                    $(modal).modal("hide"),
                )

                //todo try to add the cards without reloading the page
                location.reload()
            })
            .catch()
    })
}

export async function memoryModalNotShowAgain() {
    const modal = document.getElementById("move-from-session-modal")

    if (!modal) {
        return
    }

    const closeButton = modal.querySelector(".icon-modal-close") as HTMLButtonElement

    if (!closeButton) {
        return
    }

    closeButton.addEventListener("click", () => {
        const checkbox = modal.querySelector("#dont-ask-move-from-session-modal") as HTMLInputElement
        if (!checkbox) {
            return
        }

        if (checkbox.checked) {
            setHideMergeCookieModal()
        }
    })
}
function setHideMergeCookieModal() {
    new Cookie("hideMergeCookieModal", {
        path: "/",
        expires: Cookie.getExpireDate(3600 * 24),
        domain: SiteInfo.cookieDomain,
        value: true,
    })
}

function getHideMergeCookieModal(): boolean {
    return (
        (new Cookie("hideMergeCookieModal", {
            path: "/",
            domain: SiteInfo.cookieDomain,
        }).value as boolean) || false
    )
}
